export interface Course {
  courseId: number | null;
  sectionId: number | null;
  topicId: number | null;
  subTopicId: number | null;
  difficultyLevel: number | null;
  questionCategory: string;
  hidden?: boolean;
  sections: any[];
  topics: any[];
  subTopics: any[];
  videos?: {
    folder: string;
    videoId: string;
  }[];
}
export interface QuestionVideo {
  bunnyLibraryId: number;
  bunnyVideoId: string;
  videoId: number;
  videoName: string;
  iframeUrl: string;
  videoType: string;
  isActive: boolean;
  uploadTime: string;
  uploadedBy: string;   
  order: number;
  id: number;

}


export const questionCategories: QuestionCategory[] = [
  {
    value: 'TEST_QUESTION',
    label: 'Test Question',
  },
  {
    value: 'EXCERSIZE_QUESTION',
    label: 'Exercise Question',
  },
  {
    value: 'QUIZ_QUESTION',
    label: 'Quiz Question',
  },
];

export interface QuestionCategory {
  value: string;
  label: string;
}
